import styled from '@emotion/styled';

export const Wrapper = styled.div`
	width: 100%;
	& > :first-of-type {
		max-width: unset !important;
	}
`;

export const ApplePayWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100%;
	margin: auto;
	max-width: 24rem;
	padding: 3rem;
	${({ css }) => css}
`;
